import { LoaderCircle } from 'lucide-react';

/** Suspense fallback while a lazy route chunk loads. */
export function PageFallback() {
  return (
    <div className="flex justify-center py-16 text-primary">
      <LoaderCircle size={24} className="animate-spin" />
    </div>
  );
}
